export default {
      id: "financial-support-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#financial-support",
      toString: function () {
        return this.url;
      }
    }